import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import * as TeacherCuratorsApi from "../../../network/teacher-curator-api";
import { TeacherCuratorSignUpCredentials } from "../../../network/teacher-curator-api";
import TextInputField from "./TextInputField";

interface SignUpTeacherCuratorProps {
    setChosenCuratorId: (value:string) => void,
    setOnFinish: (b:boolean)=> void,
}

const SignUpTeacherCurator = ({setChosenCuratorId, setOnFinish}: SignUpTeacherCuratorProps) => {
    const { register, handleSubmit, formState : {errors, isSubmitting} } = useForm<TeacherCuratorSignUpCredentials>({
        defaultValues: {
            fullName:"",
            position: "",
            phone: "",
            email: "",
            telegram: "",
            login: "",
            password: "",
        }
    });

    async function onSubmit(input:TeacherCuratorSignUpCredentials) {
        let teacherCuratorResponse;
        input.telegram = input.telegram.slice(1);
        try {
            teacherCuratorResponse = await TeacherCuratorsApi.signUp(input);
        } catch (error) {
            console.error(error);
            alert(error);
        } finally {
            if(teacherCuratorResponse) {
                setChosenCuratorId(teacherCuratorResponse._id);
                setOnFinish(true);
            }

        }
    }

    return (
        <Form id="signUpTeacherCurator" onSubmit={handleSubmit(onSubmit)}>
            <TextInputField 
                name="fullName"
                label="ФИО"
                type="text"
                placeholder="ФИО"
                register={register}
                registerOptions={{required: "Required"}}
                error={errors.fullName}
            />

            <TextInputField 
                name="position"
                label="Должность"
                type="text"
                placeholder="Должность"
                register={register}
                registerOptions={{required: "Required"}}
                error={errors.fullName}
            />

            <TextInputField 
                name="phone"
                label="Телефон"
                type="phone"
                placeholder="+7(900)000-00-00"
                register={register}
                registerOptions={{required: "Required"}}
                error={errors.phone}
            />

            <TextInputField 
                name="email"
                label="Эл. почта"
                type="email"
                placeholder="name@example.com"
                register={register}
                registerOptions={{required: "Required"}}
                error={errors.email}
            />
            
            <TextInputField 
                name="telegram"
                label="Телеграм"
                type="telegram"
                placeholder="@name"
                register={register}
                registerOptions={{required: "Required"}}
                error={errors.email}
            />

            <TextInputField 
                name="login"
                label="Логин"
                type="text"
                placeholder="Введите логин"
                register={register}
                registerOptions={{required: "Required"}}
                error={errors.login}
            />

            <TextInputField 
                name="password"
                label="Пароль"
                type="password"
                placeholder="Password"
                register={register}
                registerOptions={{required: "Required"}}
                error={errors.password}
            />

            <Button
                type="submit"
                form="signUpTeacherCurator"
                disabled={isSubmitting}
                >
                    Добавить
            </Button>
        </Form>
    );
}

export default SignUpTeacherCurator;